import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../../data";

const Card = ({ p, index }) => {
  const Icon = p.icon;
  return (
    <motion.article
      data-testid={`project-${p.id}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 2) * 0.1 }}
      className={`group relative overflow-hidden rounded-sm bg-navy min-h-[340px] lg:min-h-[400px] ${p.span} col-span-1 md:col-span-4`}
    >
      <Link to={`/work/${p.id}`} data-testid={`project-link-${p.id}`} className="absolute inset-0 z-10" aria-label={`View case study: ${p.title}`} />
      <img
        src={p.image}
        alt={p.title}
        className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-70 group-hover:scale-105 transition-[transform,opacity] duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy/60 to-transparent" />

      <div className="relative h-full flex flex-col justify-between p-8 lg:p-10 pointer-events-none">
        <div className="flex items-center justify-between">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-sm bg-white/10 backdrop-blur-sm border border-white/15 text-white">
            <Icon size={22} />
          </span>
          <span className="inline-flex items-center gap-1.5 text-xs tracking-wide uppercase text-white/70 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-[opacity,transform] duration-300">
            View case study <ArrowUpRight size={14} />
          </span>
        </div>

        <div>
          <div className="flex flex-wrap gap-2 mb-4">
            {p.tags.map((t) => (
              <span key={t} className="text-[11px] tracking-wide uppercase px-2.5 py-1 rounded-sm bg-white/10 text-white/80 border border-white/10">
                {t}
              </span>
            ))}
          </div>
          <h3 className="font-serif text-2xl lg:text-3xl text-white leading-tight">{p.title}</h3>
          <p className="mt-3 text-sm text-white/70 leading-relaxed max-w-md">{p.blurb}</p>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 h-1 w-0 bg-berry group-hover:w-full transition-all duration-500 z-20" />
    </motion.article>
  );
};

export const Projects = () => {
  return (
    <section id="work" data-testid="projects-section" className="py-24 lg:py-36">
      <div className="mx-auto max-w-7xl section-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="label-caps text-berry mb-4">Selected Work</p>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-navy">
              Projects &amp; case studies
            </h2>
          </div>
          <p className="text-slate-500 max-w-sm text-sm leading-relaxed">
            A selection of the models, dashboards, and frameworks I've built to make
            finance functions sharper and faster.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-6">
          {PROJECTS.map((p, i) => (
            <Card key={p.id} p={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
